import { render, staticRenderFns } from "./new-sam-prijemka.vue?vue&type=template&id=592cde6a"
import script from "./new-sam-prijemka.vue?vue&type=script&lang=js"
export * from "./new-sam-prijemka.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./new-sam-prijemka.vue?vue&type=style&index=1&id=592cde6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports